import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import cx from '../../utils/cx.js';
import popup from '../../../app/popup';
import GalleryActionCreators from '../../actions/GalleryActionCreators.js';
import GalleryStore from '../../stores/GalleryStore';
import ImageSvg from '../images/ImageSvg.react';

const ReactPropTypes = PropTypes;

// state vērtības no store
function getStateFromStores() {
  return {
    image: GalleryStore.getCurrent(),
  };
}

class GalleryBoxToolbar extends React.PureComponent {
	static displayName = 'GalleryBoxToolbar';

	static propTypes = {
	  onClickCompliment: ReactPropTypes.func,
	};

	static defaultProps = {
	  onClickCompliment: null,
	  showReportButton: true,
	  showLikeButton: true,
	  showComplimentButton: true,
	};

	constructor(props) {
	  super(props);
	  const data = getStateFromStores();

	  // loader "Man patīk" pogai
	  data.likeButtonClicked = false;
	  // loader Report pogai
	  data.reportButtonClicked = false;

	  this.state = {
	    data: Immutable.Map(data),
	  };
	}

	setImmState = fn => this.setState((prevState) => {
	  const data = prevState.data;
	  return {
	    data: fn(data),
	  };
	});

	componentDidMount() {
	  GalleryStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
	  GalleryStore.removeChangeListener(this._onChange);
	}

	render() {
	  const data = this.state.data;
	  // bilde nav ielādēta
	  if (!data.get('image') || data.get('image').get('load_status') != 'ok') {
	    return null;
	  }

	  const self = this;

	  // Man patīk - poga
	  const LikeButton = function () {
	    // Nerāda pogu, ja:
	    // - sava bilde
	    // - ir nospiedis "Man patīk"
	    if (data.get('image').get('self') || data.get('image').get('is_liked')) {
	      return (
  <div className="galleryBoxToolbar-likes" key="likebtn">
    <div className="galleryBoxToolbar-likes-icon">
      <ImageSvg svg="icon-heart" iconClass="icon--center icon--heart" />
    </div>
    <div className="galleryBoxToolbar-likes-count">
      {data.get('image').get('likes')}
    </div>
  </div>
	      );
	    }

	    return (
  <div className="galleryBoxToolbar-likeButton" key="likebtn">
    <button
      className={cx([
							'btn btn--b btn--small btn--iconLeft',
							['has-loader', data.get('likeButtonClicked')],
						])}
      onClick={self._onClickLike}
    >
      <span>{_.get(translations, 'txt: Man patīk!', '')} ({data.get('image').get('likes')})</span>
      <span className="btn-static">
        <ImageSvg svg="icon-heart" iconClass="icon--center icon--heart" />
      </span>
    </button>
  </div>
	    );
	  };

	  // Komplimentu poga
	  const ComplimentButton = function () {
	    // Nerāda pogu, ja:
	    // - sava bilde
	    // - nav nospiedis "Man patīk"
	    // - jau nosūtīts kompliments
	    if (
	      data.get('image').get('self')
					||
					!data.get('image').get('is_liked')
					||
					data.get('image').get('is_compliment')
	    ) {
	      return null;
	    }

	    return (
  <div className="galleryBoxToolbar-complimentButton" key="complimentbtn">
    <button
      className="btn btn--b btn--small btn--iconLeft"
      onClick={self.props.onClickCompliment}
    >
      <span>{_.get(translations, 'txt: Izteikt komplimentu', '')}</span>
      <span className="btn-static">
        <ImageSvg svg="icon-likemessage" iconClass="icon--center icon--likeMessage" />
      </span>
    </button>
  </div>
	    );
	  };

	  // Ziņot par lietotāju
	  const ReportButton = function () {
	    // Nerāda pogu, ja:
	    // - sava bilde
	    // - ir nospiedis "Ziņot par bildi"
	    if (data.get('image').get('self') || data.get('image').get('reported_by_member')) {
	      return null;
	    }

	    return (
  <div className="galleryBoxToolbar-reportButton" key="reportbtn">
    <button
      className={cx([
							'btn btn--transparent btn--small btn--iconLeft',
							['has-loader', data.get('reportButtonClicked')],
						])}
      onClick={self._onClickReport}
    >
      <span>{_.get(translations, 'txt: Ziņot par bildi!', '')}</span>
      <span className="btn-static">
        <ImageSvg svg="icon-warning-2" iconClass="icon--center icon--heart" />
      </span>
    </button>
  </div>
	    );
	  };

	  const getShownButtons = function (props) {
	    const elements = [];
	    if (props.showReportButton) {
	      elements.push(ReportButton());
	    }
	    if (props.showLikeButton) {
	      elements.push(LikeButton());
	    }
	    if (props.showComplimentButton) {
	      elements.push(ComplimentButton());
	    }

	    return elements;
	  };

	  return (
  <div className="galleryBoxToolbar group">
    {getShownButtons(this.props)}
  </div>
	  );
	}

	/**
	* Event handler for 'change' events coming from the stores
	*/
	_onChange = () => {
	  const data = this.state.data;
	  const stateData = getStateFromStores();

	  // iestata default vērtības, ja mainās bilde
	  if (data.get('image').get('index') != stateData.image.get('index')) {
	    // loader "Man patīk" pogai
	    stateData.likeButtonClicked = false;
	    // loader Report pogai
	    stateData.reportButtonClicked = false;
	  }

	  // pārveido par immutable MAP, lai būtu korekts merge
	  const stateDataImm = Immutable.Map(stateData);

	  this.setImmState(data => data.merge(stateDataImm));
	};

	/**
	* Event handler for 'onClick' event, like button
	*/
	_onClickLike = () => {
	  if (_.get(globals, 'currentMember.vipOn', false)) {
	    popup.vipOnMessage();
	    return;
	  }

	  const data = this.state.data;

	  this.setImmState(data => data.update('likeButtonClicked', item => true));
	  GalleryActionCreators.likeImage(data.get('image').get('index'), data.get('image').get('file_id'));
	};

	/**
	* Event handler for 'onClick' event, report button
	*/
	_onClickReport = () => {
	  const data = this.state.data;

	  this.setImmState(data => data.update('reportButtonClicked', item => true));
	  GalleryActionCreators.reportImage(data.get('image').get('index'), data.get('image').get('file_id'), data.get('image').get('file'));
	};

	/* shouldComponentUpdate(nextProps, nextState) {
		 return React.addons.shallowCompare(this, nextProps, nextState);
		 } */
}

module.exports = GalleryBoxToolbar;
